export default __webpack_public_path__ + "static/media/default-logo.ed0561a3.png";